import { Checkbox } from '@kinesis/bungle';

import type { Flag } from '../../types';

const FeatureFlag = (props: FeatureFlagProps) => {
  const { id, enabled, editable, name, description, toggle } = props;
  return (
    <Checkbox
      key={id}
      checked={enabled}
      disabled={!editable}
      onChange={toggle}
      title={name}
    >
      {description}
    </Checkbox>
  );
};

export type FeatureFlagProps = {
  toggle: () => void;
} & Flag;
export { FeatureFlag };
